export const hebrewMessages = {
	en: 'English',
	he: 'עברית',
	pt: 'Português',
	es: 'Espanhol',
	it: 'Italiano',
	PROFILE_IMAGE: 'תמונת פרופיל',
	NAME: 'שם',
	PRICE: 'מחיר',
	SEARCH: 'חיפוש',
	IS_READ: 'נצפה',
	DATE: 'תאריך',
	DASHBOARD_WELCOME: 'ברוכים הבאים לפאנל הניהול',
	DASHBOARD: 'דשבורד',
	MONTHLY_REVENUE: 'הכנסה חודשית',
	NEW_ORDERS: 'הזמנות חדשות',
	MONTH_HISTORY: 'משתמשים חדשים שהצטרפו ב-30 הימים האחרונים',
	VEHICLE_COLORS: 'צבעי רכב',
	LEADS: 'לידים',
	FROM_DATE: 'מתאריך',
	TO_DATE: 'עד תאריך',
	GENDER: 'מין',
	FULL_NAME: 'שם מלא',
	HAS_CREDIT: 'יש קרדיט',
	BUDGET: 'תקציב',
	TOTAL: 'סה״כ',
	VEHICLE_COLOR: 'צבע רכב',
	FROM_CREATED_AT: 'שנוצרו מ-',
	TO_CREATED_AT: 'שנוצרו עד',
	COACH_FOLLOWUP: 'פולואפ מאמן',
	COACH_FOLLOWUPS: 'פולואפים מאמנים',
	ORGANIZATION_NOTIFICATION: 'התראה ארגונית',
	ORGANIZATION_NOTIFICATIONS: 'התראות ארגוניות',
	DAY_IN_MONTH: 'יום בחודש',
	NUMBER_OF_DAYS_SINCE_CLIENT_START: 'ימים מהצטרפות המתאמן',
	BODY: 'תוכן',
	VERIFICATION: 'קוד אימות',
	VERIFICATION_CODE: 'קוד אימות',
	VERIFICATIONS: 'קודי אימות',

	TRAINING_MENU: 'תכנית אימון',
	TRAINING_MENUS: 'קבצי תזונה',

	ORGANIZATION: 'ארגון',
	ORGANIZATIONS: 'ארגונים',
	TRAINEE: 'מתאמן',
	TRAINEES: 'מתאמנים',

	COACH: 'מאמן',
	COACHES: 'מאמנים',

	RECIPE_CATEGORY: 'קטגוריית מתכון',
	RECIPE_CATEGORIES: 'קטגוריות מתכונים',

	RECIPE: 'מתכון',
	RECIPES: 'מתכונים',



	TAG: 'תגית',
	TAGS: 'תגיות',

	COACH_GUIDE_CATEGORY: 'קטגוריית הדרכות מאמנים',
	COACH_GUIDE_CATEGORIES: 'קטגוריות הדרכות מאמנים',

	COACH_GUIDE: 'הדרכות מאמן',
	COACH_GUIDES: 'הדרכות מאמנים',

	PRODUCT: 'מוצר',
	PRODUCTS: 'מוצרים',

	PRODUCT_CATEGORY: 'קטגוריית מוצר',
	PRODUCT_CATEGORIES: 'קטגוריות מוצרים',

	MARATHON: 'מרתון',
	MARATHONS: 'מרתונים',

	DYNAMIC_CARD: 'קטגוריה דינאמית',
	DYNAMIC_CARDS: 'קטגוריות דינאמיות',

	BILLBOARD: 'מודעה',
	BILLBOARDS: 'באנרים',

	TRAINING: 'אימון',
	TRAININGS: 'אימונים',

	LIVE_TRAINING: 'אימון לייב',
	LIVE_TRAININGS: 'אימוני לייב',

	LIVE_TRAININGS_MESSAGE: 'אימוני לייב הודעות',
	LIVE_TRAININGS_MESSAGES: 'אימוני לייב הודעות',

	START_HOUR: 'שעת התחלה',
	END_HOUR: 'שעת סיום',

	TRAINING_CATEGORY: 'קטגוריית אימון',
	TRAINING_CATEGORIES: 'קטגוריות אימונים',

	SUCCESS_STORY_CATEGORY: 'קטגוריית סיפור הצלחה',
	SUCCESS_STORY_CATEGORIES: 'קטגוריות סיפורי הצלחה',
	SUCCESS_STORY: 'סיפור הצלחה',
	SUCCESS_STORIES: 'סיפורי הצלחה',
	IMAGE: 'תמונה',
	DESCRIPTION: 'תיאור',
	ABOUT_ORGANIZATION: 'ספר על הארגון',
	Male: 'זכר',
	Female: 'נקבה',
	FEATURED_IMAGE: 'תמונה ראשית',
	TITLE: 'כותרת',
	CONTENT: 'תוכן',
	CATEGORY: 'קטגוריה',
	CREATED_BY: 'נוצר ע״י',
	GALLERY: 'גלריה',
	DYNAMIC_CATEGORY_DEFAULT_IMAGE: 'תמונת ראשית של קטגוריות דינאמיות',
	LOGO_IMAGE: 'לוגו',
	ADDRESS: 'כתובת',
	MARATHONS_FLAG: 'האם מרתונים מופעלים?',
	SUCCESS_STORY_FLAG: 'האם לאפשר למאמנים ליצור סיפורי הצלחה דרך האפליקציה',
	COACH_FOLDER_FLAG: 'האם לאפשר לכל המתאמנים לצפות בתיקיית מאמן',
	COACH_REMINDER_EVERY: 'לתזכר את המאמנים פעם ב..',
	COACH_REMINDER_EVERY_TYPE: 'תקופה',
	TRAINEE_REMINDER_EVERY: 'לתזכר את המתאמנים פעם ב...',
	TRAINEE_REMINDER_EVERY_TYPE: 'תקופה',
	FEATURED_IMAGE_URL: 'תמונה ראשית',
	AGENDA: 'אג׳נדה',
	DURATION: 'ימים',
	PHONE: 'טלפון',
	MENU_PDF_URL: 'תפריט',
	BIRTH_DATE: 'תאריך לידה',
	EMAIL: 'אימייל',
	HEIGHT: 'גובה',
	WEIGHT: 'משקל',
	TRAINING_TYPE: 'סוג אימון',
	APPROVED_BY_COACH: 'אושרו על ידי המאמן?',
	SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS: 'התראה על מוטיבציה?',
	SHOULD_RECEIVE_WEIGHTING_REMINDER: 'התראה על שקילה?',
	SHOULD_RECEIVE_SENDING_IMAGE_REMINDER: 'התראה על צילום שקילה?',
	SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER: 'מאמן - התראה על הודעות פרטיות למתאמנים?',
	SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER: 'מאמן - התראה על התקדמות מתאמן?',
	SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS: 'מאמן - התראה על ימי הולדת?',
	SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER: 'מאמן - התראה על מתאמנים שלא נשקלו?',
	NOTE: 'הערה',
	VIDEO: 'וידאו',
	VIDEO_LINK: 'קישור לוידאו',
	YOUTUBE_LINK: 'קישור ליוטיוב',
	EXTERNAL_LINK: 'קישור חיצוני',
	IFRAME_URL: 'קישור iframe',
	CARBS: 'פחמימות',
	PROTEINS: 'חלבונים',
	LINK: 'קישור',
	NUMBER_OF_PARTICIPANTS: 'מספר משתתפים',
	TOTAL_ACTIVE_MARATHONS: 'מרתונים',
	TOTAL_ACTIVE_COACHES: 'מאמנים',
	TOTAL_ACTIVE_TRAINEES: 'מתאמנים',
	TOTAL_CLIENTS: 'סה״כ משתמשים',
	ORGANIZATION_SETTINGS: 'הגדרות ארגון',
	Admin: 'אדמין',
	Regular: 'רגיל',
	EQUALS: 'שווה',
	CONTAINS: 'מכיל',
	BETWEEN: 'בין לבין',
	Pending: 'ממתין',
	Approved: 'מאושר',
	SMS: 'SMS',
	Email: 'אימייל',
	All: 'הכל',
	Toning: 'חיטוב',
	Mass: 'מסה',
	Coach: 'מאמן',
	Trainee: 'מתאמן',
	Organization: 'ארגון',
	Vegetarian: 'טבעוני',
	Hours: 'שעות',
	Days: 'ימים',
	DAY: 'יום',
	Weeks: 'שבועות',
	Months: 'חודשים',
	LANGUAGE: 'שפה',
	HEBREW: 'עברית',
	ENGLISH: 'אנגלית',
	ITALIAN: 'איטלקית',
	TOTAL_COACHES_CREATED: 'מתאמנים שהפכו למאמנים',
	MAX_NO_WEIGHT_DAYS: 'כל כמה ימים צריך מתאמן להישקל?',
	COACH_BIRTHDAY_MESSAGE: 'הודעת יום הולדת',
	COACH_NEED_TO_WEIGHT_MESSAGE: 'הודעה למאמן כשמתאמן לא נשקל תקופה',
	COACH_FOLLOW_UP_MESSAGE: 'הודעה למאמן לפולואפ על מתאמן',
	TRAINEE_BIRTHDAY_MESSAGE: 'איזו הודעה יקבל מתאמן ביום ההולדת?',
	TRAINEE_NEED_TO_WEIGHT_MESSAGE: 'איזו הודעה יקבל מתאמן לאחר תקופה שלא נשקל בה?',
	MARATHON_WEIGHTING_REMINDER_MESSAGE: 'תוכן ההודעה שמזכירה להישקל במהלך המרתון',
	COACHES_MARATHON_WEIGHTING_REMINDER_MESSAGE: 'תוכן ההודעה שמזכירה למאמן לאסוף שקילות במרתון',
	ORGANIZATIONAL_FOLLOW_UPS: 'מתי מאמן צריך לבצע פולואפים? (מחולק בפסיקים)',
	MENU_FILE: 'קובץ תכנית',
	TYPE: 'סוג אימון',
	FROM_BMR: 'מ- BMR',
	TO_BMR: 'עד BMR',
	SEND: 'שליחה',
	ALL: 'כולם',
	SEND_NOTIFICATIONS_TO_CLIENT: 'שליחת הודעת פוש ללקוחות',
	SUCCESSFULLY_SENT_NOTIFICATION_TO_ALL: 'התראה נשלחה בהצלחה!',
	NOTIFICATIONS: 'הודעות פוש',
	GROUP_LINK: 'קישור לקבוצה',
	SPANISH: 'ספרדית',
	PORTUGEUSE: 'פורטוגזית',
	FILE: 'קובץ',
	SAVED_SUCCESSFULLY: 'נשמר בהצלחה',
	SENT_SUCCESSFULLY: 'נשלח בהצלחה',
	IMAGE_OR_VIDEO: 'תמונה או סרטון',
	RECIPIENT: 'למי לשלוח?',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_TITLE: 'כותרת התראה למאמן לגבי מתאמן שרוצה להצטרף אליו',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_DESCRIPTION: 'תיאור התראה למאמן לגבי מתאמן שרוצה להצטרף אליו',
	TRAINEE_APPROVED_NOTIFICATION_TITLE: 'כותרת התראה למתאמן שאושר ע״י המאמן שלו',
	TRAINEE_APPROVED_NOTIFICATION_DESCRIPTION: 'תיאור התראה למתאמן שאושר ע״י המאמן שלו',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_TITLE: 'כותרת התראה לגבי מתאמן שנרשם למתרון',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_DESCRIPTION: 'תיאור התראה לגבי מתאמן שנרשם למתרון',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_TITLE: 'כותרת התראה למתאמן שאושר למרתון',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_DESCRIPTION: 'תיאור התראה למתאמן שאושר למרתון',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_TITLE: 'כותרת התראה למאמן שאישר תוצאות מרתון',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_DESCRIPTION: 'תיאור התראה למאמן שאישר תוצאות מרתון',
	NEW_SUCCESS_STORY_TITLE: 'כותרת סיפור הצלחה חדש',
	NEW_SUCCESS_STORY_DESCRIPTION: 'תיאור סיפור הצלחה חדש',
	COACH_FOLDER_NAME: 'שם התייקיה לאזור מאמן',

	DETAILS: 'פרטים',
	WEIGHTINGS: 'שקילות',
	WEIGHTING: 'שקילה',
	MARATHON_DAY_NUMBER: 'יום במרתון',
	CREATED_AT: 'נוצר בתאריך',
	SUPPORTED_LANGUAGES: 'שפות נתמכות',
	DEFAULT_LANGUAGE: 'שפת ברירת מחדל',
	general: {
		error: 'שגיאה כללית'
	},
	message: {
		error: 'שגיאה כללית'
	},
	error: {
		general: 'שגיאה כללית',
		request: {
			invalid_req_params: 'נשלחו פרטים לא תקינים'
		},
		files: {
			empty: 'לא נשלח קובץ',
			unsupported_ext: 'סיומת קובץ לא נתמכת'
		},
		auth: {
			wrong_credentials: 'פרטי הזדהות לא תקינים',
			not_admin: 'אין הרשאות אדמין',
			not_client: 'אין הרשאות לקוח',
			failed_authenticating_jwt: 'משתמש לא מזוהה',
			not_registered: 'משתמש לא קיים',
			invalid_token: 'משתמש פג תוקף'
		}
	},
	resources: {
	'organization-coach-notification': { name: 'פולואפ מאמן', },
	'organization-coach-notifications': { name: 'פולואפים מאמנים', },

	'organization-notification': { name: 'התראה ארגונית', },
	'organization-notifications': { name: 'התראות ארגוניות', },

		'verification': { name: 'קוד אימות' },
		'verifications': { name: 'קודי אימות' },

		'training-menu': { name: 'תכנית אימון' },
		'training-menus': { name: 'תכניות אימונים' },

		'organization': { name: 'ארגון' },
		'organizations': { name: 'ארגונים' },

		'trainee': { name: 'מתאמן' },
		'trainees': { name: 'מתאמנים' },

		'coach': { name: 'מאמן' },
		'coaches': { name: 'מאמנים' },

		'recipe-category': { name: 'קטגוריית ממתכון' },
		'recipe-categories': { name: 'קטגוריות ממתכונים' },

		'recipe': { name: 'מתכון' },
		'recipes': { name: 'מתכונים' },

		'coach-guide-category': { name: 'קטגוריית אזור מאמנים' },
		'coach-guide-categories': { name: 'קטגוריות אזור מאמנים' },

		'coach-guide': { name: 'אזור מאמן' },
		'coach-guides': { name: 'אזור מאמנים' },

		'product': { name: 'מוצר' },
		'products': { name: 'מוצרים' },

		'product-category': { name: 'קטגוריית מוצר' },
		'product-categories': { name: 'קטגוריות מוצרים' },

		'marathon': { name: 'מרתון' },
		'marathons': { name: 'מרתונים' },

		'dynamic-card': { name: 'קטגוריה דינאמית' },
		'dynamic-cards': { name: 'קטגוריות דינאמיות' },

		'billboard': { name: 'מודעה' },
		'billboards': { name: 'באנרים' },

		'training': { name: 'אימון' },
		'trainings': { name: 'אימונים' },

		'training-category': { name: 'קטגוריית אימון' },
		'training-categories': { name: 'קטגוריות אימונים' },

		'success-story-category': { name: 'קטגוריית סיפור הצלחה' },
		'success-story-categories': { name: 'קטגוריות סיפורי הצלחה' },
		'success-story': { name: 'סיפור הצלחה' },
		'success-stories': { name: 'סיפורי הצלחה' },
		'vehicle-color': { name: 'צבע רכב' },
		'lead': { name: 'ליד' }
	},
	ra: {
		action: {
			clear_input_value: 'נקה',
			delete: 'מחק',
			unselect: 'בטל בחירה',
			sort: 'מיון',
			show: 'הצג',
			undo: 'שחזר',
			confirm: 'אישור',
			bulk_actions: 'נבחרו %{smart_count} פריטים',
			list: 'רשימה',
			export: 'ייצוא',
			save: 'שמור',
			create: 'צור',
			edit: 'ערוך',
			cancel: 'ביטול',
			refresh: 'רענן',
			add_filter: 'הוסף סינון',
			remove_filter: 'הסר סינון',
			back: 'חזור'
		},
		boolean: {
			true: 'כן',
			false: 'לא'
		},
		page: {
			list: 'רשימת %{name}',
			edit: '%{name} #%{id}',
			show: '%{name} #%{id}',
			empty: 'לא נמצאו תוצאות',
			invite: 'מקווים שממש בקרוב יגיע לפה מידע...',
			create: 'צור %{name}',
			delete: 'מחק %{name} #%{id}',
			dashboard: 'דשבורד',
			not_found: 'לא קיים',
			error: 'שגיאה'
		},
		input: {
			references: {
				single_missing: 'חסר'
			},
			file: {
				upload_several:
					'גרור מספר קבצים להעלאה או לחץ לבחור אחד.',
				upload_single: 'גרור קובץ להעלאה או לחץ לבחור אחד.'
			},
			image: {
				upload_several:
					'גרור מספר תמונות להעלאה או לחץ לבחור אחת.',
				upload_single:
					'גרור תמונה להעלאה או לחץ לבחור אחת.'
			}
		},
		message: {
			error: 'אופס.. קרתה שגיאה',
			invalid_form: 'טופס לא תקין',
			yes: 'כן',
			no: 'לא',
			are_you_sure: 'האם את/ה בטוח/ה ?',
			about: 'אודות',
			not_found:
				'הכנסת כתובת שגויה או לחצת על קישור לא תקין',
			delete_title: 'מחיקה',
			delete_content: 'האם אתה בטוח שברצונך למחוק?',
			bulk_delete_title: 'שים לב!',
			bulk_delete_content: 'האם אתה בטוח שברצונך למחוק את כל המידע הזה?'
		},
		navigation: {
			no_results: 'לא נמצאו תוצאות',
			page_rows_per_page: 'מס׳ שורות בעמוד',
			skip_nav: 'דילוג',
			page_out_of_boundaries: 'עמוד %{page} מחוץ לתחום',
			page_out_from_end: 'לא ניתן להמשיך מעבר לעמוד האחרון',
			page_out_from_begin: 'לא ניתן לגשת לפני העמוד הראשון',
			page_range_info: '%{offsetBegin}-%{offsetEnd} מתוך %{total}',
			next: 'הבא',
			prev: 'הקודם'
		},
		auth: {
			username: 'שם משתמש',
			password: 'סיסמא',
			sign_in: 'כניסה',
			sign_in_error: 'הכניסה נכשלה, אנא נסו שנית',
			logout: 'התנתקות',
			auth_check_error: 'הזדהות לא הצליחה'
		},
		notification: {
			data_provider_error: 'תקלה בתקשורת מידע',
			updated: 'פריט עודכן בהצלחה',
			created: 'פריט נוצר בהצלחה',
			deleted: 'פריט נמחק בהצלחה',
			item_doesnt_exist: 'פריט לא קיים',
			http_error: 'שגיאה בהתקשרות מול השרת'
		},
		validation: {
			required: 'שדה חובה',
			minLength: 'חייב להכיל לפחות %{min} תווים',
			maxLength: 'יכול להכיל לכל היותר %{max} תווים',
			minValue: 'חייב להיות לפחות %{min}',
			maxValue: 'חייב להיות %{max} או פחות',
			number: 'חייב להיות מספר',
			email: 'כתובת דוא"ל לא תקנית'
		}
	}
};
